var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 28,
    viewBox: "0 0 26 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 3C9.68629 3 7 5.68629 7 9V13.5C7 15.1569 6.32843 16.7452 5.13172 17.9048L3.65685 19.3337C2.92386 20.0438 3.42777 21.2857 4.44497 21.2857H21.555C22.5722 21.2857 23.0761 20.0438 22.3431 19.3337L20.8683 17.9048C19.6716 16.7452 19 15.1569 19 13.5V9C19 5.68629 16.3137 3 13 3ZM4.5 9C4.5 4.30558 8.30558 0.5 13 0.5C17.6944 0.5 21.5 4.30558 21.5 9V13.5C21.5 14.5451 21.9238 15.5452 22.6783 16.2762L24.1531 17.7051C26.352 19.8353 24.8403 23.562 21.7887 23.562H16.9127C16.5286 25.3702 14.9227 26.7269 13 26.7269C11.0773 26.7269 9.47137 25.3702 9.08731 23.562H4.2113C1.1597 23.562 -0.35201 19.8353 1.84688 17.7051L3.32174 16.2762C4.07621 15.5452 4.5 14.5451 4.5 13.5V9ZM13 24.4412C13.8821 24.4412 14.6146 23.8291 14.8085 23H11.1915C11.3854 23.8291 12.1179 24.4412 13 24.4412Z",
    fill: "#525252"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notificationIcon.659414e5611427d93c668316c3dbd547.svg";
export { ForwardRef as ReactComponent };